const mainNavigation = {
	el: {
		root: document.querySelector<HTMLElement>(".main-navigation"),
		trigger: document.querySelector<HTMLButtonElement>(
			".main-navigation__button",
		),
		hamburger: document.getElementById("hamburger-icon"),
		header: document.querySelector<HTMLElement>(".header"),
	},

	init() {
		this.el.trigger.addEventListener("click", async () => {
			this.el.root.classList.toggle("open");
			this.el.trigger.classList.toggle("enabled");
			this.el.hamburger.classList.toggle("clicked");
			this.el.header.classList.toggle("infinity");
		});
	},
};

export default mainNavigation;
